<template>
  <label class="reaction">
    <div class="reaction__column">
      <div>
        <input type="checkbox" :value="reaction.uuid" v-model="selected" />
      </div>
      <div>{{ formattedDateTime(reaction.reacted_at) }}</div>
      <div>
        <div class="notification" :class="reaction.notification_read_at && 'notification--read'"></div>
      </div>
    </div>

    <div class="reaction__column">
      <div>
        <Link :to="`/routes/${reaction.route.uuid}`">{{ reaction.route.name }}</Link>
      </div>
      <div>
        <span v-if="reaction.comment">{{ reaction.comment }}</span>
        <ImageComponent v-if="reaction.attachment" :src="reaction.attachment" />
      </div>
      <div>
        <Link v-for="group in reaction.groups" :key="group.uuid" :to="`/container_groups/${group.uuid}`">{{
          group.name
        }}</Link>
      </div>
    </div>
  </label>
</template>

<script>
import ImageComponent from '@/components/Image'
import Link from '@/components/Link'
import dateUtils from '@/components/mixins/dateUtils'

export default {
  components: { ImageComponent, Link },
  mixins: [dateUtils],
  props: {
    reaction: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value.includes(this.reaction.uuid)
      },
      set(value) {
        if (value) {
          this.$emit('input', [...this.value, this.reaction.uuid])
        } else {
          this.$emit(
            'input',
            this.value.filter(uuid => uuid !== this.reaction.uuid),
          )
        }
      },
    },
  },
}
</script>

<style lang="scss">
.reaction {
  display: block;
  padding: 1rem;
  cursor: default;

  &:hover {
    background: #f5f5f5;

    &:has(input:checked) {
      background: #f0f0f0;
    }
  }

  &:has(input:checked) {
    background: #e9e9e9;
  }
}

.reaction__column {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;

  /* flex children */
  > * {
    flex: 0 0 calc((100% - 1rem) / 3);
    line-height: 1.25rem;

    &:first-child {
      text-align: left;
    }

    &:last-child {
      text-align: right;
    }

    &:not(:first-child):not(:last-child) {
      text-align: center;
    }
  }

  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  .image-component {
    margin-top: 0.75rem;
  }
}

.notification {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 0.5rem;
  background-color: blue;

  &.notification--read {
    background-color: transparent;
  }
}
</style>
